// extracted by mini-css-extract-plugin
module.exports = {"flex":"Tab_flex__29ApK","img":"Tab_img__a1vpi","active":"Tab_active__3gVB_","paragraph":"Tab_paragraph__18iqj"};